module.exports = __webpack_public_path__ + "img/cover-slot-bg.8a65b3eb.jpg";